<template>
    <footer v-if="showFooter">
        <p>Daniel Long | Freelance Web Developer</p>
        <p>&copy; {{getYear()}}</p>
    </footer>
</template>

<script>
export default {
  name: 'Footer',
  props: ['showFooter'],
  data() {
    return {
      //
    }
  },
  methods: {
    getYear() {
        return new Date().getUTCFullYear();
    }
  }
}
</script>

<style lang="scss">

</style>
